const handleMobileNav = () => {
	const $navTrigger = $('.nav-trigger');

	$navTrigger.on('click', function(event) {
		$('.header__navigation').toggleClass('is-open');

		event.preventDefault();
	});
}

handleMobileNav();
